import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Container,
  Divider,
  Link,
  Stack
} from '@mui/material';
import { Copyright as CopyrightIcon } from '@mui/icons-material';
import { getBuildInfo } from '../../services/buildInfo';

const Footer = () => {
  const [buildInfo, setBuildInfo] = useState(null);

  useEffect(() => {
    const loadBuildInfo = async () => {
      try {
        const info = await getBuildInfo();
        setBuildInfo(info);
      } catch (error) {
        
      }
    };

    loadBuildInfo();
  }, []);

  const currentYear = new Date().getFullYear();
  const copyrightHolder = buildInfo?.copyright?.holder || 'ypkim';
  const copyrightYear = buildInfo?.copyright?.year || currentYear;
  const version = buildInfo?.version || 'unknown';

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 2,
        backgroundColor: (theme) => 
          theme.palette.mode === 'light' 
            ? theme.palette.grey[100] 
            : theme.palette.grey[900],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          {/* 저작권 정보 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CopyrightIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              {copyrightYear} {copyrightHolder}. All rights reserved.
            </Typography>
          </Box>

          {/* 시스템 정보 */}
          <Stack
            direction="row"
            divider={<Divider orientation="vertical" flexItem />}
            spacing={1}
            alignItems="center"
          >
            <Typography variant="caption" color="text.secondary">
              GPU KVM API Server
            </Typography>
            <Typography variant="caption" color="text.secondary">
              v{version}
            </Typography>
            {buildInfo?.gitHash && buildInfo.gitHash !== 'unknown' && (
              <Typography variant="caption" color="text.secondary">
                {buildInfo.gitHash}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer; 